// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"40":"ea85a606752fc4577bd1","221":"a5ff5d83024fcc2415a0"}[chunkId] + ".css";
};